import { motion } from 'framer-motion';
import { ScrambleText } from './ScrambleText';

export const ChevronDown = ({ onClick, className = '', currentSection }) => {
  // Remove the line below that hides the chevron for 'join-us'
  // if (currentSection === 'join-us') return null;

  // Define sections array consistently with HomePage.js inside the component or pass it as a prop
  // For simplicity, defining it here for now. Make sure it matches HomePage.js
  const sections = ['landing', 'big-shift', 'who-we-are', 'join-us', 'careers'];

  const isLanding = currentSection === 'landing';
  const currentIndex = sections.indexOf(currentSection);
  const totalSections = sections.length;


  // Ensure currentSection exists in the updated array before proceeding
  if (currentIndex === -1) return null; // Or handle appropriately

  return (
    <motion.div
      className={`cursor-pointer fixed bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10 ${className}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: isLanding ? 0.4 : 0.6 }}
      whileHover={{ opacity: 1 }}
      onClick={onClick}
    >
      {/* Show section indicator only if not landing and section is found */}
      {!isLanding && (
        <div className="text-sm font-mono text-[#5f6563]">
          <ScrambleText
            key={`${currentIndex}-${totalSections}`} // Add key for re-render on change
            text={`${currentIndex + 1}/${totalSections}`}
            scrambleDuration={400}
            scrambleSpeed={30}
            glitchIntensity={0.05}
            enabled={currentIndex !== -1} // Enable only if section is valid
          />
        </div>
      )}
      <motion.div className="relative">
        <ScrambleText
          text="↓"
          className="text-5xl text-[#16B08B] hover:text-[#01CBA0] transition-colors duration-300"
          scrambleDuration={800}
          scrambleSpeed={50}
          glitchIntensity={0.1}
        />
      </motion.div>
    </motion.div>
  );
};

// Remove the outdated sections array from here
// const sections = ['landing', 'big-shift', 'who-we-are', 'neo', 'join-us']; 